/**
 * Sanitiza texto para compatibilidad estricta con el portal BHE del SII (CGI).
 * El portal del SII opera bajo codificación antigua (ISO-8859-1) donde caracteres
 * como tildes se corrompen en el timbraje (ej: 'Asesoría' -> 'AsesorA a') y prohíbe
 * caracteres CGI especiales: ! # % & + = \ | [ ] { } < > ?
 *
 * Normalización inteligente y transparente:
 *   # -> N° (muy común en direcciones chilenas: 'Av. Providencia #123' -> 'Av. Providencia N° 123')
 *   & -> y  (muy común en glosas o empresas: 'Diseño & Web' -> 'Diseno y Web')
 *   + -> y  (muy común en glosas: 'Soporte + Mantenimiento' -> 'Soporte y Mantenimiento')
 *   Elimina: ! % = \ | [ ] { } < > ?
 *   Normaliza diacríticos y tildes (á, é, í, ó, ú, ñ -> a, e, i, o, u, n) para blindar el PDF oficial del SII.
 *   Normaliza espacios en blanco redundantes.
 */
export function sanitizeBheText(input: string | undefined | null): { cleaned: string; hadInvalid: boolean } {
  if (!input) return { cleaned: "", hadInvalid: false };

  let cleaned = input
    .replace(/#/g, "N° ")
    .replace(/&/g, " y ")
    .replace(/\+/g, " y ")
    .replace(/[!%=\\|\[\]{}<>?]/g, "");

  // Normalización de tildes y diacríticos vía Unicode NFD
  cleaned = cleaned
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

  const hadInvalid = cleaned !== input.trim();
  return { cleaned, hadInvalid };
}
